"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.describeVTPFDifference = describeVTPFDifference;
const transformVehicleTypeToString_1 = require("../transformers/transformVehicleTypeToString");
function describeVTPFDifference(originalVehicleTypesPricesFees, updatedVehicleTypesPricesFees) {
    let changed = false;
    let message = "The following prices have changed:\n";
    for (const vt in updatedVehicleTypesPricesFees) {
        const newPrice = updatedVehicleTypesPricesFees[vt];
        const oldPrice = originalVehicleTypesPricesFees[vt];
        if (oldPrice && newPrice.price + newPrice.fee != oldPrice.price + oldPrice.fee) {
            changed = true;
            message += `${(0, transformVehicleTypeToString_1.transformVehicleTypeToString)(Number(vt))} was changed from ${oldPrice.price + oldPrice.fee} to ${newPrice.price + newPrice.fee}\n`;
        }
    }
    if (!changed) {
        return;
    }
    return message;
}
//# sourceMappingURL=describeVTPFDifference.js.map